import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../layout/Layout";
import Loader from "utils/Loader";

const Auth = lazy(() => import("../components/auth/AuthLayout"));
const CandidateLogin = lazy(
  () => import("../components/auth/login/CandidateLogin"),
);
const CandidateSheet = lazy(
  () => import("../components/views/candidate/CandidateSheet"),
);
const Error404 = lazy(() => import("../components/error/Error404"));
const Maintainance = lazy(() => import("../components/error/Maintainance"));
const Authenticate = lazy(
  () => import("../components/auth/forgot/Authenticate"),
);

function LandingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Auth />} />
        <Route path="/" element={<Auth />} />
        <Route path="/au" element={<Authenticate />} />
        <Route path="/candidate-login" element={<CandidateLogin />} />
        <Route path="/sheet" element={<CandidateSheet />} />
        <Route path="/404" element={<Error404 />} />
        <Route path="/maintainance" element={<Maintainance />} />
        <Route path="*" element={<Auth />} />
      </Route>
    </Routes>
  );
}

export default LandingRoutes;
